import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = {
  key: 1,
  class: "py-2"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "children-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_class_growth_record_row = _resolveComponent("class-growth-record-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: '成長記録一覧', href: '/growth-record', color: 'primary' },
          { title: `${_ctx.className} の成長記録` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: `${_ctx.className} の成長記録`
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_month_pager, {
        modelValue: _ctx.yearMonth,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonth) = $event)),
        onInput: _ctx.pageClick
      }, null, 8, ["modelValue", "onInput"])
    ]),
    (_ctx.hasAbnormalValue)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "error",
          density: "compact",
          class: "mb-3",
          title: "入力値にエラーがあります"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" 入力された数値が大きすぎます。小数点（.）の打ち忘れを確認してください ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.recordRequests.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            disabled: _ctx.isSaving || _ctx.hasAbnormalValue,
            onClick: _ctx.saveRecords
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" 保存する ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_linear, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"children-table__headers\" data-v-9aef4624><div class=\"children-table__header col-name\" data-v-9aef4624>園児氏名</div><div class=\"children-table__header col-height\" data-v-9aef4624>身長 (cm)</div><div class=\"children-table__header col-weight\" data-v-9aef4624>体重 (kg)</div><div class=\"children-table__header col-other\" data-v-9aef4624>備考</div></div>", 1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
        return (_openBlock(), _createBlock(_component_class_growth_record_row, {
          key: r.child.childId,
          record: r,
          onInputHeight: ($event: any) => (_ctx.inputHeight($event, r)),
          onInputWeight: ($event: any) => (_ctx.inputWeight($event, r)),
          onInputRemarks: ($event: any) => (_ctx.inputRemarks($event, r))
        }, null, 8, ["record", "onInputHeight", "onInputWeight", "onInputRemarks"]))
      }), 128))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showErrorAlert,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showErrorAlert) = $event)),
      "max-width": "450"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 text-error font-weight-bold" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" ⚠️ 保存できません ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" 入力値に異常（許容範囲外の数値）が含まれているため、保存できません。", -1),
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" 正しい数値を入力し直してください。 ", -1),
                _createElementVNode("ul", { class: "mt-3 text-caption text-error" }, [
                  _createElementVNode("li", null, "身長の許容範囲: 30cm 〜 200cm"),
                  _createElementVNode("li", null, "体重の許容範囲: 1kg 〜 100kg")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showErrorAlert = false))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" 閉じる ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}